module.exports = __webpack_public_path__ + "img/signupTop.9311f65e.svg";